import React, { useState, useEffect, useMemo } from 'react'
import {
  Table,
  Form,
  Button,
  Modal,
  FormGroup,
  FormLabel,
  FormSelect,
  Row,
  Col,
  Card} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { FaEdit, FaUser } from 'react-icons/fa'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsPencilFill } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { hasValidInstituteIdCookie } from '../utils/instituteIdCookie'
import axios from 'axios'
import EditAssignClass from './EditAssignClass'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { Table as ResponsiveTable, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'

const AssignClass = () => {
  const {token, logout} = useAuth()
  const { isCollapsed } = useSidebar()
  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()

  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)
  // const [assignedClasses, setAssignedClasses] = useState([])
  const [studentCount, setStudentCount] = useState(null)
  const [countColor, setCountColor] = useState('') // Add color for the response
  const [selectedNewCourse, setSelectedNewCourse] = useState('')
  const [courses, setCourses] = useState([])
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  const [classes, setClasses] = useState([])
  const [teachers, setTeachers] = useState([])
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!hasValidInstituteIdCookie()) return
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(() => {})
  }, [])
  useEffect(() => {
    const userLogged = Cookies.get('user')
    const userRoleLogged = Cookies.get('role')
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
    if (userRoleLogged) {
      try {
        setUserRole(JSON.parse(userRoleLogged))
        console.log('User:', JSON.parse(userRoleLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
        if (user.user_type === 'teacher') return
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId)}

        console.log('Request Headers:', headers)

        const response = await axios.get(
          BASE_URL+'/class/all',
          { headers },
        )

        console.log('Students response: ', response.data.data)

        setClasses(response.data.data) // ✅ FIXED: show data in table
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  useEffect(() => {
    const userCookie = Cookies.get('user')
    const instituteId = Cookies.get('institute_id')

    console.log('Raw user cookie:', userCookie)
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
        console.log('My user is :', user.user_type)
        if (user.user_type === 'teacher') return
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(instituteId)}

        const response = await axios.get(
          BASE_URL+'/teacher/all',
          { headers },
        )

        console.log('Teachers response:', response.data.data)
        setTeachers(response.data.data)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    // const userCookie = Cookies.get('user')
    // const teacher_id = teachers.id
    let teacherToken = null
    let adminToken = null

    // If user is a teacher, fetch their classes
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        teacherToken = user.token
        if (user.user_type === 'teacher') {
          teacherToken = user.token
          const teacher_id = user.teacher_id
          console.log('TEACHER - ID : ', teacher_id)
          axios
            .get(BASE_URL+`/teacher-classes`, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${teacherToken}`}})
            .then((res) => {
              console.log('Teacher class response:', res.data.data)
              const teacherClassData = res.data.data
              console.log('teacherClassData', teacherClassData.teacher_name)
              setData(teacherClassData)
            })
            .catch((err) => {
              console.error('Teacher API error:', err.response?.data?.message)
            })
        }
        // If admin, fetch all assigned classes
        else {
          try {
            const user = JSON.parse(userCookie)
            adminToken = user.token

            axios
              .get(
                BASE_URL+'/get/all/assigned/classes',
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${adminToken}`,
                    'institute-Id': Number(instituteId)}},
              )
              .then((res) => {
                console.log('Assigned class response:', res.data.data)
                setData(res.data.data)
              })
              .catch((err) => {
                toast.error(
                  err.response?.data?.message || 'Something went wrong',
                )
              })
          } catch (err) {
            console.error('Parse admin cookie failed', err)
          }
        }
      } catch (err) {
        console.error('Parse user cookie failed', err)
      }
    }
  }, [loading])

  useEffect(() => {
    fetchAssignedClasses()
  }, [])

  const [newAssignedTeacher, setNewAssignedTeacher] = useState({
    teacher_id: '',
    course_id: '',
    class_id: []})

  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return []
    return data.filter((item) =>
      Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search.trim().toLowerCase()),
      ),
    )
  }, [data, search])

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewAssignedTeacher((prev) => ({ ...prev, [name]: value }))
    console.log('name', name, 'value', value)
  }

  // Add New Teacher
  const handleSave = async (e) => {
    e.preventDefault()
    if (!newAssignedTeacher?.course_id || !newAssignedTeacher?.class_id?.length) {
      toast.error('Please select course and at least one class.')
      return
    }

    try {
      setLoading(true)
      const headers = {
        Authorization: `Bearer ${user.token}`}
      const payload = {
        ...newAssignedTeacher,
        class_ids: newAssignedTeacher.class_id,
        headers}
      console.log('Sending data: ', newAssignedTeacher)
      const response = await ApiEndpoints.addAssignClass(payload)
      console.log('Response during post', response)
      setNewAssignedTeacher('Response: ', response)
      // setData(response.data)
      // Reset the form after submission
      setNewAssignedTeacher({
        teacher_id: '',
        course_id: '',
        class_id: []})
      setSelectedNewCourse('')
      setClasses([])
      setCourseTouched(false)
      setStudentCount(null)
      setCountColor('')

      toast.success(response.data.result)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.data?.result)
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const [courseTouched, setCourseTouched] = useState(false)

  const handleCourseChange = (e) => {
    const courseId = e.target.value
    setNewAssignedTeacher((prev) => ({ ...prev, course_id: courseId, class_id: [] }))

    console.log('Selected course Id:', courseId)
    setCourseTouched(true)
    setSelectedNewCourse(courseId)
    setStudentCount(null)
    setCountColor('')
    console.log('Cleared Classes')

    if (courseId) {
      ApiEndpoints.getAllClassesByCourseId(courseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            // toast.error('No classes found for this course.')
            setClasses([])
            setStudentCount(null)
          } else {
            setClasses(data.data)
            // setUpdatedStudent(data.data)
          }
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            // toast.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            // toast.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }

  const fetchStudentCount = (classId) => {
    fetch(
      BASE_URL + `/get/class/student/count?class_id=${classId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`}},
    )
      .then((response) => response.json())
      .then((data) => {
        if (
          data?.status &&
          data?.data?.current !== undefined &&
          data?.data?.maximum_limit !== undefined
        ) {
          const current = data.data.current === null ? 0 : data.data.current
          const maximum_limit = parseInt(data.data.maximum_limit, 10)
          setStudentCount({ current, maximum_limit })
          setCountColor('green')
        } else {
          setStudentCount('No data available')
          setCountColor('red')
        }
      })
      .catch((error) => {
        console.error('Error fetching student count:', error)
        setStudentCount('Error fetching data')
        setCountColor('red')
      })
  }

  const handleClassChange = (e) => {
    const { value: classId, checked } = e.target

    setNewAssignedTeacher((prev) => {
      const selectedClasses = Array.isArray(prev.class_id) ? prev.class_id : []
      const updatedClassIds = checked
        ? [...new Set([...selectedClasses, classId])]
        : selectedClasses.filter((id) => id !== classId)

      // Keep current class seat indicator behavior for a single selected class only.
      if (updatedClassIds.length === 1) {
        fetchStudentCount(updatedClassIds[0])
      } else {
        setStudentCount(null)
        setCountColor('')
      }

      return { ...prev, class_id: updatedClassIds }
    })
  }
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])
  const handleRefresh = async () => {
    setSearch('')
    setCurrentPage(1)
    fetchAssignedClasses()
  }
  const fetchAssignedClasses = async () => {
    const instituteId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token

        if (user.user_type === 'teacher') {
          const res = await axios.get(
            BASE_URL+`/teacher-classes`,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`}},
          )
          const teacherClassData = res.data.data
          // const assigned = teacherClassData?.assigned_classes || []
          // setData(assigned)
          setData(teacherClassData)
        } else {
          const res = await axios.get(
            BASE_URL+'/get/all/assigned/classes',
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
                'institute-Id': Number(instituteId)}},
          )
          setData(res.data.data)
        }
      } catch (error) {
        console.error('Error fetching assigned classes:', error)
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }
  }
  const handleNavigateToCreateClass = () => {
    navigate('/AddClass')
  }
  return (
    <>
      <style>
        {`
          .blinking-link {
            color: blue;
            text-decoration: none;
            cursor: pointer;
            animation: blink 1s infinite;
            font-weight:bold;
          }

          @keyframes blink {
            0% { color: blue; }
            50% { color: red; }
            100% { color: blue; }
          }
          @media (max-width: 767.98px) {
          .responsive-btn {
            margin-top:5px !important;
            padding: 0.25rem 0.5rem !important;
            font-size: 0.875rem !important; /* equivalent to btn-sm */
          }
      `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Assign Icon Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Assign Classes
              </h3>
              {/* {user?.user_type !== 'teacher' && (
                <button
                  onClick={() => setShowModal(true)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#223843',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Add New Assign"
                >
                  <FaUser size={18} />
                </button>
              )} */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          {user?.user_type !== 'teacher' && (
            <>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex align-items-center gap-3">
                {/* Items Per Page Selector */}
                <div 
                  className="d-flex align-items-center"
                  style={{
                    backgroundColor: '#ffffff',
                    padding: '8px 16px',
                    borderRadius: '8px',
                    gap: '8px',
                    border: '1px solid #D1D3D4'}}
                >
                  <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    Show:
                  </span>
                  <Form.Select
                    className="w-auto"
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(parseInt(e.target.value))
                      setCurrentPage(1)
                    }}
                    style={{
                      borderRadius: '6px',
                      border: '1px solid #D1D3D4',
                      backgroundColor: '#ffffff',
                      color: '#111827',
                      fontSize: '13px',
                      fontWeight: '500',
                      padding: '4px 32px 4px 12px',
                      minWidth: '140px',
                      transition: 'all 0.2s ease',
                      cursor: 'pointer',
                      height: '36px',
                      fontFamily: 'Inter, system-ui, sans-serif'}}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#223843'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = '#D1D3D4'
                    }}
                  >
                    <option value="10">10 per page</option>
                    <option value="20">20 per page</option>
                    <option value="30">30 per page</option>
                  </Form.Select>
                </div>
                <button
                  onClick={() => setShowFilterCard(!showFilterCard)}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                    border: '1px solid #D1D3D4',
                    color: showFilterCard ? '#ffffff' : '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                    e.currentTarget.style.color = '#ffffff'
                    e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                    e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                    e.currentTarget.style.borderColor = '#D1D3D4'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
                >
                  <BsFunnelFill size={20} />
                </button>
              </div>

              {/* Add New — desktop (mobile below, match CreateAnnouncement.js) */}
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <FaUser size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Assign
                </span>
              </button>
            </div>

            <div className="d-md-none d-flex justify-content-end mb-4">
              <button
                type="button"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New"
              >
                <FaUser size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Assign
                </span>
              </button>
            </div>
            </>
          )}

          {/* Modern Filter Section */}
          {user?.user_type !== 'teacher' && (
            <div 
              style={{
                maxHeight: showFilterCard ? '1000px' : '0',
                overflow: 'hidden',
                transition: 'max-height 0.3s ease-in-out',
                marginBottom: showFilterCard ? '24px' : '0'}}
            >
              {showFilterCard && (
                <Card 
                  style={{
                    border: '1px solid #D1D3D4',
                    borderRadius: '12px',
                    backgroundColor: '#ffffff',
                    overflow: 'hidden'}}
                >
                  {/* Header */}
                  <div 
                    style={{
                      background: '#ffffff',
                      padding: '20px',
                      borderBottom: '1px solid #F3F4F6'}}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex align-items-center gap-3">
                        <div 
                          style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'}}
                        >
                          <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                        </div>
                        <div>
                          <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Search Teachers
                          </h5>
                          <p className="m-0 mt-1 text-start" style={{fontSize: '13px', color: '#6b7280' }}>
                            Find assigned classes by teacher name
                          </p>
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          onClick={handleRefresh}
                          style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            border: 'none',
                            color: '#ffffff',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'scale(1.05)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#223843'
                            e.currentTarget.style.transform = 'scale(1)'
                          }}
                          title="Refresh"
                        >
                          <BsArrowClockwise size={20} />
                        </button>
                      </div>
                    </div>
                  </div>

                  <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                    <Row className="g-3">
                      <Col xs={12}>
                        <div style={{ position: 'relative' }}>
                          <label className="fw-semibold text-start mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Search Teacher Name
                          </label>
                          <div style={{ position: 'relative' }}>
                            <BsSearch 
                              style={{ 
                                position: 'absolute', 
                                left: '12px', 
                                top: '50%', 
                                transform: 'translateY(-50%)',
                                color: '#6b7280',
                                fontSize: '16px',
                                zIndex: 1}} 
                            />
                            <Form.Control
                              type="text"
                              placeholder="Enter teacher name..."
                              value={search}
                              onChange={(e) => setSearch(e.target.value)}
                              style={{
                                paddingLeft: '40px',
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                fontSize: '14px',
                                height: '40px',
                                transition: 'all 0.2s ease',
                                backgroundColor: '#ffffff',
                                fontFamily: 'Inter, system-ui, sans-serif'}}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#223843'
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#D1D3D4'
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              )}
            </div>
          )}

        {user?.user_type == 'teacher' && (
          <div className="mb-5"></div>
        )}

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          <ResponsiveTable className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Teacher Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Assigned Class</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Assigned Course</Th>
                {user?.user_type !== 'teacher' && <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>}
              </Tr>
            </Thead>
            <Tbody>
              {(() => {
                if (user?.user_type === 'teacher') {
                  const assignedClasses = data?.assigned_classes || []

                  if (assignedClasses.length === 0) {
                    return (
                      <Tr>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{data?.teacher_name || 'Unknown Teacher'}</Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>No Assigned Classes</Td>
                        <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>No Assigned Course</Td>
                      </Tr>
                    )
                  }

                  return assignedClasses.map((cls, index) => (
                    <Tr 
                      key={cls.id}
                      style={{ 
                        backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                        transition: 'background-color 0.2s ease',
                        borderBottom: '1px solid #E5E7EB'}}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                      }}
                    >
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{data.teacher_name}</Td>
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{cls.class_name}</Td>
                      <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{cls.course_name || cls.course || 'N/A'}</Td>
                    </Tr>
                  ))
                }

                // Non-teacher users (e.g., admin)
                if (currentItems.length === 0) {
                  return (
                    <Tr>
                      <Td
                        colSpan={user?.user_type !== 'teacher' ? 4 : 3}
                        className="text-center"
                        style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}
                      >
                        No records found
                      </Td>
                    </Tr>
                  )
                }

                let rowIndex = 0
                return currentItems
                  .filter((item) => item.teacher_name !== 'Unknown Teacher')
                  .flatMap((item) => {
                    const assignedClasses = item.assigned_classes || []

                    if (assignedClasses.length === 0) {
                      const currentIndex = rowIndex++
                      return (
                        <Tr 
                          key={`${item.teacher_id}-no-classes`}
                          style={{ 
                            backgroundColor: currentIndex % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                            transition: 'background-color 0.2s ease',
                            borderBottom: '1px solid #E5E7EB'}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = currentIndex % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                          }}
                        >
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.teacher_name}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>No Assigned Classes</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>No Assigned Course</Td>
                          <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                            <div className="d-flex flex-wrap justify-content-center gap-2">
                              <button
                                onClick={() => {
                                  setSelectedClass({
                                    teacher_id: item.teacher_id,
                                    id: null,
                                    class_id: null})
                                  setShowEditModal(true)
                                }}
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  borderRadius: '50%',
                                  backgroundColor: '#10B981',
                                  border: 'none',
                                  color: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s ease',
                                  cursor: 'pointer'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#059669'
                                  e.currentTarget.style.transform = 'scale(1.1)'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.transform = 'scale(1)'
                                }}
                                title="Edit Assign"
                              >
                                <BsPencilFill size={16} />
                              </button>
                            </div>
                          </Td>
                        </Tr>
                      )
                    }

                    return assignedClasses.map((cls) => {
                      const currentIndex = rowIndex++
                      return (
                        <Tr
                          key={`${item.teacher_id}-${cls.id}`}
                          style={{ 
                            backgroundColor: currentIndex % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                            transition: 'background-color 0.2s ease',
                            borderBottom: '1px solid #E5E7EB'}}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = currentIndex % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                          }}
                        >
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.teacher_name}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{cls.class_name}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{cls.course_name || cls.course || 'N/A'}</Td>
                          <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                            <div className="d-flex flex-wrap justify-content-center gap-2">
                              <button
                                onClick={() => {
                                  setSelectedClass({
                                    teacher_id: item.teacher_id,
                                    id: cls.id,
                                    class_id: cls.class_id})
                                  setShowEditModal(true)
                                }}
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  borderRadius: '50%',
                                  backgroundColor: '#10B981',
                                  border: 'none',
                                  color: '#ffffff',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s ease',
                                  cursor: 'pointer'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#059669'
                                  e.currentTarget.style.transform = 'scale(1.1)'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.transform = 'scale(1)'
                                }}
                                title="Edit Assign"
                              >
                                <BsPencilFill size={16} />
                              </button>
                            </div>
                          </Td>
                        </Tr>
                      )
                    })
                  })
              })()}
            </Tbody>
          </ResponsiveTable>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="records"
        />
        </div>
      </div>

        <Modal
          size="lg"
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
        >
          <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
            <Modal.Title>Add new class to teacher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSave}>
              {/* <Form.Group className="mb-3">
              <Form.Label>Class</Form.Label>
              <Form.Select
                name="class_id"
                value={newAssignedTeacher.class_id}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Class</option>
                {classes.map((clas) => (
                  <option key={clas.id} value={clas.id}>
                    {clas.class_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}

              <Form.Group className="mb-3">
                <Form.Label>Course *</Form.Label>
                <Form.Select
                  name="course_id"
                  value={selectedNewCourse}
                  onChange={handleCourseChange}
                >
                  <option value="">Select Course</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>
                      {course.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {classes.length === 0 && selectedNewCourse && (
                <p style={{ color: 'red', letterSpacing: '1px' }}>
                  The selected course has no class. Please{' '}
                  <span
                    className="blinking-link"
                    onClick={handleNavigateToCreateClass}
                  >
                    click here
                  </span>{' '}
                  to create new class.
                </p>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Class *</Form.Label>
                <div
                  style={{
                    border: '1px solid #ced4da',
                    borderRadius: '0.375rem',
                    padding: '10px 12px',
                    backgroundColor:
                      !courseTouched || classes.length === 0 ? '#e9ecef' : '#fff',
                    maxHeight: '180px',
                    overflowY: 'auto'}}
                >
                  {!courseTouched ? (
                    <div style={{ color: '#6c757d' }}>Select course first</div>
                  ) : classes.length === 0 ? (
                    <div style={{ color: '#6c757d' }}>No classes available</div>
                  ) : (
                    classes.map((clas) => (
                      <Form.Check
                        key={clas.id}
                        type="checkbox"
                        id={`assign-class-${clas.id}`}
                        label={clas.class_name}
                        value={clas.id}
                        checked={newAssignedTeacher.class_id?.includes(String(clas.id))}
                        onChange={handleClassChange}
                        className="mb-2"
                      />
                    ))
                  )}
                </div>
              </Form.Group>

              {studentCount !== null && studentCount !== 'No data available' && (
                <div
                  style={{
                    color: countColor,
                    marginBottom: '5px',
                    fontWeight: 'bold',
                    letterSpacing: '1px'}}
                >
                  {studentCount.current === null
                    ? `There are still ${studentCount.maximum_limit} seats available in this class.`
                    : studentCount.current === studentCount.maximum_limit
                    ? 'There are no more seats available in this class.'
                    : `There are ${
                        studentCount.maximum_limit - studentCount.current
                      } seats left in this class.`}
                </div>
              )}

              <FormGroup className="mb-3">
                <FormLabel>Teachers</FormLabel>
                <FormSelect
                  name="teacher_id"
                  value={newAssignedTeacher.teacher_id}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Teacher</option>
                  {teachers.map((teacher) => (
                    <option key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </option>
                  ))}
                </FormSelect>
              </FormGroup>
              <Form.Group className="mb-3">
                <Form.Check
                  className="text-danger"
                  type="checkbox"
                  id="acknowledgeCheckbox"
                  label="I acknowledge and agree that this process is irreversible and cannot be undone."
                  checked={isAcknowledged}
                  onChange={(e) => setIsAcknowledged(e.target.checked)}
                />
              </Form.Group>
              <Modal.Footer>
                <Button variant="danger" onClick={() => setShowModal(false)}>
                  Cancel
                </Button>
                <Button
                  variant="success"
                  type="submit"
                  disabled={!isAcknowledged}
                >
                  Save Assign
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>
        <EditAssignClass
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          assignData={selectedClass}
          onUpdate={fetchAssignedClasses}
        />
    </>
  )
}

export default AssignClass
